<template>
  <div>
    <span>场景目录: </span>
    <el-select
      v-model="sceneDirId"
      placeholder="请选择场景目录"
      filterable="true"
      style="width: 240px;margin-left: 13px;"
    >
      <el-option v-for="(item, index) in sceneDirList" :key="index" :label="$t(item.label)" :value="item.id">
      </el-option>
    </el-select>
    <div style="text-align: center; margin-top: 20px;">
      <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="onConfirm">
        确定
      </el-button>
      <el-button class="sky-branch-pattern__add" style="margin-top:5px" @click="onCancel">
        取消
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { SCENE_DIR_MNG, SCENE_MNG } from '@/api/apiModules'

export default {
  name: 'SkyBatchUpdateSceneDir',
  inject: ['rootView'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    rowIds: {},
    industryId: {}
  },
  data() {
    return {
      loading: false,
      sceneDirList: [],
      sceneDirId: null
    }
  },
  mounted() {
    action(SCENE_DIR_MNG, 'findAllActive').then(response => {
      this.sceneDirList = response.data.content.itemArr
        .filter(item => {
          return item.industryId == this.industryId
        })
        .map(item => {
          return {
            id: item.id,
            label: item.sceneDirName
          }
        })
    })
  },
  computed: {},
  watch: {},
  methods: {
    onConfirm() {
      if (!this.sceneDirId) {
        this.$store.dispatch('OpenNotification', { message: '请选择场景目录', type: 'error' })
        return
      }

      const request = {
        sceneIdArr: this.rowIds,
        sceneDirId: this.sceneDirId
      }

      this.rootView.loading = true
      action(SCENE_MNG, 'batchUpdateSceneDir', request)
        .then(response => {
          this.$emit('cb')
          this.$store.dispatch('OpenNotification', {
            message: '批量更新场景目录成功【仅对业务场景生效】',
            type: 'success'
          })
        })
        .catch(e => {
          throw e
        })
    },
    onCancel() {
      this.$emit('cb')
    }
  }
}
</script>
